import { render, staticRenderFns } from "./MerchantDetail.vue?vue&type=template&id=3ea92dc6&scoped=true&"
import script from "./MerchantDetail.vue?vue&type=script&lang=js&"
export * from "./MerchantDetail.vue?vue&type=script&lang=js&"
import style0 from "./MerchantDetail.vue?vue&type=style&index=0&id=3ea92dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea92dc6",
  null
  
)

export default component.exports